import { InMemoryCache } from '@apollo/client';

import generatedIntrospection, { scalarTypePolicies } from '../../graphql/generated/graphql';

export const getApolloCache = (): InMemoryCache => {
  return new InMemoryCache({
    typePolicies: {
      ...scalarTypePolicies,
      // Flight segments coming from different offers reuse the same id (e.g. segment-1-1),
      // so we disable keying to keep each itinerary's segments isolated in the cache.
      FlightSegment: { keyFields: false },
      FlightItinerary: { keyFields: false },
      FlightFare: { keyFields: false },
      // A committed trip is presented as one offer per leg that all share the bundle id (the whole-trip id the
      // order resolves), so normalising FlightOffer by id would merge the legs and render one of them twice.
      FlightOffer: { keyFields: false },
      // Rooms, rates and bed groups carry the provider's catalogue ids, so a fresh search of a booked hotel
      // would otherwise overwrite that booking's cached rate with today's.
      AccommodationRoom: { keyFields: false },
      AccommodationRoomRate: { keyFields: false },
      AccommodationBedConfiguration: { keyFields: false },
      // No id on this type, so without this the mutation results never merge into the cached list.
      Integration: { keyFields: ['name'] },
    },
    possibleTypes: generatedIntrospection.possibleTypes,
  });
};
